"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = {
    userName: '',
    userEmail: '',
    accountName: '',
    platformVersion: 2,
    permissionScopes: [],
    settings: {
        keyPaths: [],
        ticketingFeatureEnabled: false,
    },
}, action) => {
    if (action.type === 'FETCH_USER_SUCCESS') {
        return action.user;
    }
    return state;
};
exports.getUser = (state) => state;
exports.getSettings = (state) => state.settings;
